/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Truncate from 'react-truncate';
import {
  Button,
} from '@edx/paragon';
import { injectIntl, defineMessages } from 'gatsby-plugin-react-intl';
import { intlShape } from '@prospectus/common/types/intlShape';

import CourseRating from './CourseRating';

function CourseHeader({
  intl,
  title,
  subtitle,
  courseReview,
  mobile,
}) {
  const DESCRIPTION_LINE_LENGTH = 3;
  const [expanded, setExpanded] = useState(false);

  const toggleLines = () => {
    setExpanded(!expanded);
  };

  const messages = defineMessages({
    'prospectus.course.header.show-all': {
      id: 'prospectus.course.header.show-all',
      defaultMessage: 'show all',
      description: 'Link label that shows full text of course description',
    },
  });

  if (mobile) {
    return (
      <div className="col-md-7">
        <h1 dangerouslySetInnerHTML={{ __html: title }} />
        <Truncate
          lines={!expanded && DESCRIPTION_LINE_LENGTH}
          ellipsis={(
            <span>... <Button className="show-all-button" variant="link" size="inline" onClick={toggleLines}>{intl.formatMessage(messages['prospectus.course.header.show-all'])}</Button></span>
          )}
        >
          <span className="mb-0" dangerouslySetInnerHTML={{ __html: subtitle }} />
        </Truncate>
      </div>
    );
  }

  return (
    <div className="col-md-7 pr-4">
      <h1 dangerouslySetInnerHTML={{ __html: title }} />
      {courseReview ? <CourseRating {...courseReview} /> : null}
      <div className="p" dangerouslySetInnerHTML={{ __html: subtitle }} />
    </div>
  );
}

CourseHeader.propTypes = {
  intl: intlShape.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  mobile: PropTypes.bool,
  courseReview: PropTypes.shape({
    reviewsCount: PropTypes.number,
    avgCourseRating: PropTypes.number,
  }),
};

CourseHeader.defaultProps = {
  mobile: false,
  courseReview: null,
};

export default injectIntl(CourseHeader);
